import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../layout/Layout";
import Line from "../assets/img/Line.png";
import { GoSearch } from "react-icons/go";
import { AiOutlinePlus, AiFillDelete } from "react-icons/ai";
import { GrFormNext, GrFormPrevious } from "react-icons/gr";
import { CiEdit } from "react-icons/ci";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { HiOutlineEye } from "react-icons/hi";

import Confirm from "../assets/img/confirm.png";
import "react-phone-input-2/lib/style.css";

import axiosInstanceAuth from "../../apiInstances/axiosInstanceAuth";
import useEncryption from "../useEncryption/useEncryption";
import { usePagination } from "../Pagination/usePagination";

import { toast } from "react-toastify";
import { PropagateLoader } from "react-spinners";
import Adduserpopup from "./Adduserpopup";

const AddUser = () => {
  const navigate = useNavigate();
  const { decryptData } = useEncryption();

  const [userRole, setUserRole] = useState(""); // Role wise manage
  const [allUser, setAllUser] = useState([]); // use User Table time this state

  const [showForm, setShowForm] = useState(false); // Success Popup Open
  const [isLoading, setIsLoading] = useState(false); // Success Popup Open
  const [open, setOpen] = React.useState(false); // Add user popup open

  const [getId, setId] = useState(""); // use Delete API
  const [showModal, setShowModal] = React.useState(false); // Delete Popup

  const [openEdit, setOpenEdit] = React.useState(false); // Edit Form Open
  const [editData, setEditData] = useState({}); // Edit API Data set
  const [getEditId, setEditID] = useState(); // Edit click ID get and set

  const [search, setSearch] = useState("");
  const [filterdAllUsers, setFilterdAllUsers] = useState([]); // Use Filter
  const { sliceData, currentPage, numbers, totalPages, goToPage } =
    usePagination(filterdAllUsers, 10);

  // Search
  const HendalSearch = (e) => {
    setSearch(e.target.value);
  };

  useEffect(() => {
    const results = allUser.filter((item) => {
      const searchTerm = search.toLowerCase();
      const itemNameMatch =
        item?.name?.toLowerCase().includes(searchTerm) ||
        item?.email?.toLowerCase().includes(searchTerm) ||
        item?.phone?.toLowerCase().includes(searchTerm) ||
        item?.employeRole?.toLowerCase().includes(searchTerm);
      return itemNameMatch;
    });
    setFilterdAllUsers(results);
    goToPage(1);
  }, [search]);

  // Get All User Show
  const getUserdata = async () => {
    await axiosInstanceAuth
      .get("/viewalluser")
      .then((res) => {
        const myData = decryptData(res?.data?.data);
        setAllUser(myData?.data || []);
        setFilterdAllUsers(myData?.data || []);

        console.log("UserTableData---->", myData);
      })
      .catch((err) => {
        console.log("err --->", err);
      });
  };

  useEffect(() => {
    getUserdata();
  }, []);

  useEffect(() => {
    const userRole = localStorage.getItem("Role");
    if (userRole) {
      setUserRole(userRole);
    }
  }, []);

  // Open add form
  const handleOpen = () => setOpen(!open);

  // Delete API
  const DeleteApi = async () => {
    await axiosInstanceAuth
      .get(`userDelete/${getId}`)
      .then((res) => {
        const myDeleteData = decryptData(res?.data?.data);
        console.log("Delete Done --->", myDeleteData);
        if (myDeleteData.status) {
          getUserdata();
          toast.success(myDeleteData?.message);
        } else {
          toast.error(myDeleteData?.message);
        }
        setShowModal(false);
      })
      .catch((err) => {
        console.log("err --->", err);
      });
  };

  // Delete Modal Open
  const modelShows = (id) => {
    setShowModal(true);
    setId(id);
  };

  // Edit ID Wise Data Show API.
  const onChangeEdit = (e) => {
    const { name, value } = e.target;
    setEditData({
      ...editData,
      [name]: value,
    });
  };

  const myeditdata = {
    name: editData?.name,
    email: editData?.email,
    employeRole: editData?.employeRole,
    phone: editData?.phone,
  };

  // Get Data Particular ID Wise in Form
  const getEditData = async (id) => {
    await axiosInstanceAuth
      .get(`userData/${id}`)
      .then((res) => {
        setOpenEdit(true);
        setEditID(id);
        const myEditData = decryptData(res?.data?.data);
        setEditData(myEditData?.data);
        // console.log("first")
        console.log("Edit Data ID Wise --->", myEditData?.data);
      })
      .catch((err) => {
        console.log("err --->", err);
      });
  };

  // Updata Data Submit clcik
  const handleEditSubmit = async () => {
    await axiosInstanceAuth
      .post(`update_user/${getEditId}`, myeditdata)
      .then((res) => {
        const myData = decryptData(res?.data?.data);
        console.log("=========myData", myData);
        console.log("=========logToken", myData?.data?.token);
        if (myData?.status) {
          getUserdata();
          toast.success(myData?.message);
        } else {
          toast.error(myData?.message);
        }
      })
      .catch((err) => {
        console.log("err --->", err);
      });
  };

  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setOpenEdit(false);
      }
    };

    // Attach the event listener when the component mounts.
    document.addEventListener("mousedown", handleClickOutside);

    // Remove the event listener when the component unmounts to prevent memory leaks.
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setOpenEdit]);
  useEffect(() => {
    if (isLoading === true) {
      const loadingTimeout = setTimeout(() => {
        // setOpenEdit(true);
        getUserdata();
        setIsLoading(false);
      }, 2000);
      return () => {
        clearTimeout(loadingTimeout); // Clear the timeout if the component unmounts
      };
    }
  }, [isLoading]);

  const userFolderViewData = (id) => {
    localStorage.setItem("UserId", id);
    navigate(`/userfolderview/${id}`);
  };

  return (
    <>
      <Layout className="container">
        <div className="md:flex justify-between lg:my-10 my-3">
          <div className="flex lg:text-[30px] text-[20px] font-semibold gap-3 justify-center items-center">
            <img src={Line} alt="" className="h-7" />
            <h1 className="text-[#22345C]">Add User</h1>
          </div>
          <div class="relative">
            <input
              class="shadow-md pl-10  rounded-lg lg:w-96 text-[#9F9F9F] text-[16px] py-2 px-3  focus:outline-none"
              id="username"
              type="text"
              placeholder="Search"
              value={search}
              onChange={HendalSearch}
            />

            <div class="absolute left-0 inset-y-0 flex py-2 ">
              <GoSearch size={20} className="ml-3 text-[#22345C]" />
            </div>
          </div>
        </div>

        {userRole !== "user" && (
          <button
            onClick={handleOpen}
            class="bg-[#22345C] gap-1  text-[#FFFFFF] font-sans text-lg font-bold py-3 px-4 rounded-[10px] inline-flex items-center"
          >
            <AiOutlinePlus size={25} className="text-[#FFFFFF]" />
            <span>Add User</span>
          </button>
        )}

        {/* Add User popup */}
        {open && <Adduserpopup setOpen={setOpen} setIsLoading={setIsLoading} />}

        {/* Edit User Popup  */}
        {openEdit && (
          <>
            <div className="fixed top-0 left-[0%] z-[9999999999999] w-full h-full  backdrop-brightness-50 grid place-items-center place-content-center ">
              <div
                className="h-auto  filter-screen-model outline-none bg-white rounded-2xl shadow-2xl mx-5 "
                ref={modalRef}
              >
                <div>
                  <div>
                    <div className=" border-[1.5px] border-[#000000] m-10 rounded-[20px] p-">
                      <div className="flex justify-center items-center">
                        <div className="absolute">
                          <button class="bg-[#22345C] text-lg text-white font-sans underline font-bold py-2 px-4 rounded-[10px]">
                            Edit User
                          </button>
                        </div>
                      </div>
                      <div className="p-5">
                        <div class="grid grid-cols-1 gap-6 mt-4 lg:grid-cols-2">
                          <div>
                            <label
                              class="text-[#000000] font-sans font-semibold text-lg"
                              for="username"
                            >
                              Full Name
                              <span className="text-red-500">*</span>{" "}
                              <span className="text-[#929292]">(Required)</span>
                            </label>
                            <input
                              type="text"
                              class="block w-full px-2 py-2 mt-2 text-[#000000] bg-white border border-[#233966] rounded-md outline-none"
                              name="name"
                              value={editData?.name}
                              onChange={onChangeEdit}
                            />
                          </div>

                          {/* <div>
                            <label
                              class="text-[#000000] font-sans font-semibold text-lg"
                              for="username"
                            >
                              Employee Role
                              <span className="text-red-500">*</span>{" "}
                              <span className="text-[#929292]">(Required)</span>
                            </label>

                            <select
                              class="border-black border-[1px] px-2 py-2 mt-2 text-[#000000] font-sans  rounded-md   block w-full p-2.5 focus:outline-none"
                              name="employeRole"
                              value={editData?.employeRole}
                              onChange={onChangeEdit}
                            >
                              <option selected disabled>
                                Choose a any
                              </option>
                              <option>Supervisior</option>
                              <option>Team Leader</option>
                              <option>Project Manager</option>
                              <option>Chief Engineer</option>
                              <option>Other</option>
                            </select>
                          </div> */}
                          <div>
                            <label
                              class="text-[#000000] font-sans font-semibold text-lg"
                              for="username"
                            >
                              Employee Role
                              <span className="text-red-500">*</span>{" "}
                            </label>

                            <input
                              type="text"
                              class="border-black border-[1px] px-2 py-2 mt-2 text-[#000000] font-sans  rounded-md   block w-full p-2.5 focus:outline-none"
                              name="employeRole"
                              value={editData?.employeRole}
                              onChange={onChangeEdit}
                            />
                          </div>
                          <div>
                            <label
                              class="text-[#000000] font-sans font-semibold text-lg"
                              for="username"
                            >
                              Email<span className="text-red-500">*</span>{" "}
                              <span className="text-[#929292]">(Required)</span>
                            </label>
                            <input
                              type="email"
                              class="block w-full px-2 py-2 mt-2 text-[#000000] bg-white border border-[#233966] rounded-md outline-none"
                              name="email"
                              value={editData?.email}
                              onChange={onChangeEdit}
                            />
                          </div>

                          <div>
                            <label
                              class="text-[#000000] font-sans font-semibold text-lg"
                              for="username"
                            >
                              Phone<span className="text-red-500">*</span>{" "}
                              <span className="text-[#929292]">(Required)</span>
                            </label>
                            <input
                              type="text"
                              class="block w-80 px-2 py-2 mt-2 text-[#000000] bg-white border border-[#233966] rounded-md outline-none"
                              name="phone"
                              value={editData?.phone}
                              onChange={onChangeEdit}
                            />
                          </div>
                        </div>
                      </div>

                      <div class="flex justify-center mt-10 gap-4 mb-5">
                        <div>
                          <button
                            onClick={() => {
                              handleEditSubmit();
                              setOpenEdit(false);
                            }}
                            class="bg-[#5DC90A] px-6 py-2 leading-5  text-white font-bold  rounded-[10px]"
                          >
                            Save
                          </button>
                        </div>
                        <div>
                          <button
                            onClick={() => setOpenEdit(false)}
                            class="bg-[#FF270E] px-6 py-2 leading-5 text-white font-bold rounded-[10px]"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {/* Add User and success popup open code second popup */}
        {showForm ? (
          <>
            <div className="fixed top-0 left-[0%] z-[9999999999999] w-full h-full  backdrop-brightness-50 grid place-items-center place-content-center ">
              <div className="h-auto  filter-screen-model outline-none  rounded-2xl shadow-2xl mx-5 ">
                {/* <div className="absolute inset-0 bg-gray-800 opacity-75" /> */}
                <div className="relative">
                  <div className="bg-[#17C09E] rounded-t-[10px] shadow-lg z-10 h-4"></div>
                  <div className="bg-white p-5 rounded-b-[23px] shadow-lg z-10">
                    <div className=" border-[1.5px] border-[#000000] m-2 rounded-[10px] ">
                      <div className="p-5">
                        <div className="flex justify-center">
                          <img src={Confirm} alt="" />
                        </div>
                        <div>
                          <p className="text-[#000000] mt-5 mx-24 font-sans font-bold text-2xl">
                            New User Is Added Successfully
                          </p>
                        </div>
                        <div className="flex justify-center">
                          <button
                            className="mt-8 bg-[#22345C] text-white font-semibold py-1 justify-center px-8 rounded-[18px] focus:outline-none  "
                            onClick={() => setShowForm(false)}
                          >
                            Okay
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : null}

        {/* User Data Show in Table Format  */}
        {isLoading ? (
          <div className="loading-animation flex justify-center items-center pt-80">
            <PropagateLoader color="#22345C" />
            {/* ...loading */}
          </div>
        ) : (
          <>
            <div>
              <div className="overflow-auto lg:overflow-visible mt-10">
                <table className="table w-full text-gray-400 border-separate space-y-6">
                  <thead className="bg-[#22345C] text-white lg:text-xl">
                    <tr>
                      <th className="p-3 text-left ">Full Name</th>
                      <th className="p-3 text-left ">Email Address</th>
                      <th className="p-3 text-left ">Role</th>
                      <th className="p-3 text-left">Phone Number</th>
                      <th className="p-3 text-center">Options</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sliceData?.length > 0 &&
                      sliceData.map((d, index) => (
                        <tr
                          key={index}
                          className="bg-[#F5F7FD] shadow-lg lg:text-black font-bold font-sans text-lg"
                        >
                          <td className="p-3">{d.name}</td>
                          <td className="p-3">{d.email}</td>
                          <td className="p-3">{d.employeRole}</td>
                          <td className="p-3">{d.phone}</td>

                          <td className="p- ">
                            <div className="relative gap-2 flex items-center justify-center  ">
                              <div>
                                <button>
                                  <CiEdit
                                    onClick={() => {
                                      getEditData(d._id);
                                    }}
                                    size={30}
                                    className="cursor-pointer  text-[#FFFFFF] bg-[#22345C] rounded-[3px] p-1"
                                  />
                                </button>
                              </div>
                              <div>
                                <button>
                                  <MdOutlineDeleteOutline
                                    onClick={() => modelShows(d._id)}
                                    size={30}
                                    className="cursor-pointer text-[#FFFFFF]  bg-[#FF270E] rounded-[3px] p-1"
                                  />
                                </button>
                                {showModal ? (
                                  <>
                                    <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                                      <div className="relative w-auto my-6 mx-auto max-w-3xl">
                                        <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                                          <div className="relative p-6 flex-auto">
                                            <span className="justify-center items-center flex">
                                              <AiFillDelete className="w-16 h-16 fill-red-500" />
                                            </span>
                                            <p className="my-4 text-center leading-relaxed text-2xl text-red-500">
                                              Are You Sure ?
                                            </p>
                                            <p className="my-4 text-slate-500 text-lg leading-relaxed">
                                              You want to Delete this User
                                            </p>
                                          </div>

                                          <div className="flex gap-2 items-center justify-end p-3 border-t border-solid border-slate-200 rounded-b">
                                            <button
                                              onClick={() =>
                                                setShowModal(false)
                                              }
                                              class="text-red-500   font-bold py-2 px-6 rounded"
                                            >
                                              No
                                            </button>
                                            <button
                                              onClick={DeleteApi}
                                              class="bg-emerald-500 active:bg-emerald-600 px-6 py-2  text-white font-bold  rounded"
                                            >
                                              Yes
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                                  </>
                                ) : null}
                              </div>
                              <div>
                                <button>
                                  <HiOutlineEye
                                    onClick={() => {
                                      userFolderViewData(d?._id);
                                    }}
                                    size={30}
                                    className="cursor-pointer  text-[#FFFFFF] bg-[#22345C] rounded-[3px] p-1.5"
                                  />
                                </button>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}

        {/* pagination Code  */}
        {allUser?.length > 10 ? (
          <div className="flex gap-2 pb-5 bottom-0">
            <button
              className="px-1 py-1 leading-tight  bg-[#FFFFFF] rounded-lg text-black text-xl"
              disabled={currentPage === 1}
              onClick={() => goToPage(currentPage - 1)}
            >
              <GrFormPrevious size={25} />
            </button>

            {numbers.map((item, index) => (
              <button
                disabled={item === "..."}
                className={`py-[3px] px-3  rounded-lg ${
                  currentPage === item &&
                  "bg-[#22345C] text-white font-bold font-sans"
                }`}
                onClick={() => goToPage(item)}
                key={index}
              >
                {item}
              </button>
            ))}

            <button
              className=" px-1 py-1  leading-tight  bg-[#FFFFFF] rounded-lg text-black text-xl"
              disabled={currentPage === totalPages}
              onClick={() => goToPage(currentPage + 1)}
            >
              <GrFormNext size={25} />
            </button>
          </div>
        ) : null}

        <div>
          <style
            dangerouslySetInnerHTML={{
              __html:
                "\n\n    .table {\n    border-spacing: 0 15px;\n  }\n\n  i {\n    font-size: 1rem !important;\n  }\n\n  .table tr {\n    border-radius: 20px;\n  }\n\n  tr td:nth-child(n + 5),\n  tr th:nth-child(n + 5) {\n    border-radius: 0 0.625rem 0.625rem 0;\n  }\n\n  tr td:nth-child(1),\n  tr th:nth-child(1) {\n    border-radius: 0.625rem 0 0 0.625rem;\n  }\n\n",
            }}
          />

          <link
            href="https://fonts.googleapis.com/css?family=Material+Icons|Material+Icons+Outlined|Material+Icons+Two+Tone|Material+Icons+Round|Material+Icons+Sharp"
            rel="stylesheet"
          />
        </div>
      </Layout>
    </>
  );
};

export default AddUser;
